module.exports = __webpack_public_path__ + "img/游戏封面.9963a097.png";